import { LRDecoder, InterpolationSpecType } from "@orbis-lr-sdk/orbis-lr-sdk";

export function lrDecode(key, lrTag) {
  const decoder = new LRDecoder().withInterpolationSpecType(
    InterpolationSpecType.TAG,
  );
  return decoder.decode(key, lrTag);
}

export function lrDecodeRelation(lrTag) {
  const decoder = new LRDecoder().withInterpolationSpecType(
    InterpolationSpecType.ROLE,
  );
  return decoder.decode(lrTag);
}
